import React from 'react';

import { TOpsClassesMeta } from '../../../types';
import { Card, labelClass } from '../ui';
import { fieldClass, TClassForm, TSetField } from './shared';

type Props = {
  form: TClassForm;
  set: TSetField;
  meta?: TOpsClassesMeta;
};

/** Instructor, the client's requirements, and the trainer-facing notes. */
const TrainerSection: React.FC<Props> = ({ form, set, meta }) => (
  <Card title="Trainer Info">
    <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-2">
      <div>
        <label className={labelClass}>Primary assigned instructor</label>
        <input
          className={fieldClass}
          list="ops-instructors"
          value={form.instructorName}
          onChange={(e) => set('instructorName')(e.target.value)}
        />
        <datalist id="ops-instructors">
          {meta?.instructors.map((n) => <option key={n} value={n} />)}
        </datalist>
      </div>
      <div>
        <label className={labelClass}>Requested instructor</label>
        <input
          className={fieldClass}
          placeholder="Who the client asked for, if anyone"
          value={form.requestedInstructor}
          onChange={(e) => set('requestedInstructor')(e.target.value)}
        />
      </div>
      <div className="md:col-span-2">
        <label className={labelClass}>Instructor requirement</label>
        <input
          className={fieldClass}
          placeholder="e.g. must have taught Power BI to finance teams"
          value={form.instructorRequirement}
          onChange={(e) => set('instructorRequirement')(e.target.value)}
        />
      </div>
      <div>
        <label className={labelClass}>Reason for the session</label>
        <textarea
          className={fieldClass}
          rows={3}
          value={form.reasonForSession}
          onChange={(e) => set('reasonForSession')(e.target.value)}
        />
      </div>
      <div>
        <label className={labelClass}>Audience information</label>
        <textarea
          className={fieldClass}
          rows={3}
          value={form.audienceInformation}
          onChange={(e) => set('audienceInformation')(e.target.value)}
        />
      </div>
      <div className="md:col-span-2">
        <label className={labelClass}>Project notes (trainer-facing)</label>
        <textarea
          className={fieldClass}
          rows={4}
          placeholder="What the instructor needs to know for this class — shown on the trainer view"
          value={form.trainerNotes}
          onChange={(e) => set('trainerNotes')(e.target.value)}
        />
      </div>
    </div>
  </Card>
);

export default TrainerSection;
